export default "__VITE_ASSET__CFRnxg5C__"